<script>
/*
 * Чтобы сниппеты работали - достаточно добавить нужный компонент сниппета в components.
 * Строка сниппета должна выглядеть так:
 * [snippet :type='SnippetButton' :content='{"text": "моя кнопка"}']
 * вначале в одинарных кавычках идет название компонента,
 * затем также в одинарных кавычках содержимое (json), которое передается внутрь компонента.
 */

import Button from '~/components/snippets/ButtonSnippet/Button.vue';

export default {
	name: 'ParseSnippet',
	props: [
		'content',
	],
	data() {
		return {
			snippetComponents: {
				Button,
			},
		};
	},
	computed: {
		dynamicComponent() {
			return {
				template: `<div>${this.htmlWithSnippets}</div>`,
				components: this.snippetComponents,
			};
		},
		htmlWithSnippets() {
			if (!this.content) return '';

			const contentWithoutTagP = this.content.replace(/<p>(?<content>.*?)<\/p>/gis, '$<content>');

			const regexp = /\[snippet\s*:type='(\w+)'\s*:content='([^']*)']/gis;
			const replaceSnippets = (match, type, content) => {
				if (!this.snippetComponents[type]) return match;
				let safeContent = content.replace(/'/g, '&#39;');
				safeContent = content.replace(/&nbsp;/g, ' ');

				return `<${type} content='${safeContent}' />`;
			};

			return contentWithoutTagP.replace(regexp, replaceSnippets);
		},
	},
	render(h) {
		return h(this.dynamicComponent);
	},
};
</script>
